/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="attribute-wrapper">
    <div class="attribute-row">
      <p>{{ compositionValue }}</p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'AccordionCareComposition',
  props: {
    attribute: {
      type: Object,
      required: true
    },
    product: {
      type: Object,
      required: true
    },
    variantSelected: {
      type: Array | Object,
      required: false
    }
  },
  computed: {
    compositionValue () {
      const key = this.attribute.key
      if (Array.isArray(this.variantSelected) && this.variantSelected.length === 1) {
        var obj = this.variantSelected[0].attributesLabel.find((v) => v.attribute_code === key)
        return obj.value || this.attribute.value
      } else {
        return this.attribute.value
      }
    }
  }
}
</script>
